const l = {
  name: "BallSoccer",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31,0,20,0z M2,20c0-0.8,0.1-1.6,0.2-2.4L8,14.2l5,2.9v5.8
			l-5,2.9l-5.8-3.4C2.1,21.6,2,20.8,2,20z M7,12.5L2.7,15C3.5,12.1,5,9.6,7,7.6V12.5z M14,15.4l-5-2.9V5.8c1.3-1,2.7-1.8,4.2-2.4
			L19,6.7v5.8L14,15.4z M15.7,2.5C17.1,2.2,18.5,2,20,2c1.5,0,2.9,0.2,4.3,0.5L20,5L15.7,2.5z M21,6.7l5.8-3.4
			C28.3,4,29.7,4.8,31,5.8v6.7l-5,2.9l-5-2.9V6.7z M20,14.2l5,2.9v5.8l-5,2.9l-5-2.9v-5.8L20,14.2z M21,27.5l5-2.9l5,2.9v6.7
			c-1.3,1-2.7,1.8-4.2,2.4L21,33.3V27.5z M19,33.3l-5.8,3.4c-1.5-0.6-2.9-1.4-4.2-2.4v-6.7l5-2.9l5,2.9V33.3z M15.7,37.5L20,35
			l4.3,2.5C22.9,37.8,21.5,38,20,38C18.5,38,17.1,37.8,15.7,37.5z M7,32.4c-2-2.1-3.5-4.6-4.3-7.4L7,27.5V32.4z M33,32.4v-4.9
			l4.3-2.5C36.5,27.9,35,30.4,33,32.4z M32,25.8l-5-2.9v-5.8l5-2.9l5.8,3.4c0.1,0.8,0.2,1.6,0.2,2.4c0,0.8-0.1,1.6-0.2,2.4L32,25.8z
			 M33,12.5V7.6c2,2.1,3.5,4.6,4.3,7.4L33,12.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as BallSoccer
};
